import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import appHistory from '../../history';

// components
import ForgotPassword from '../../components/Auth/ForgotPassword';
// css
import './Auth.css';

const RecoveryPage = observer(
class RecoveryPage extends Component {
  constructor(props) {
    super(props);
    this.timeout = null;
  }

  componentWillUnmount() {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  render() {
    return (
      <div className="AuthPage-container">
        <div className="AuthPage-control">
          <ForgotPassword onReset={this.passwordOnReset}/>
        </div>
        <div className="AuthPage-switch-link">
          <Link to="/auth/login">Nevermind, I remember now</Link>
        </div>
      </div>
    );
  }

  passwordOnReset = (isSuccess) => {
    if (isSuccess) {
      this.timeout = window.setTimeout(() => {
        appHistory.push("/auth/login");
      }, 10 * 1000);
    }
  }
});

export default RecoveryPage;


// WEBPACK FOOTER //
// ./src/pages/Auth/RecoveryPage.js